<template>
  <div style="height: 100%">
    <div id="mynetwork"></div>
    <div id="nInfos"></div>
  </div>
</template>

<script>
import vis from "vis-network/dist/vis-network";
import Config from "@/config";
export default {
  name: "Vis",
  props: {
    companies: {
      type: Array,
      default: () => []
    }
  },
  async mounted() {
    await this.$nextTick();
    let edgeId = 1;
    var nodes = [];
    var edges = [];

    for (const company of this.companies) {
      nodes.push({
        id: company._id.toString(),
        label: company.name,
        title: company.name,
        shape: "circularImage",
        image: this.config.filesUrl + company.instance + "/logo/" + company.logo
      });
      for (const supplier of company.suppliers) {
        edges.push({
          id: edgeId,
          from: company._id,
          to: supplier,
          arrows: "to",
          dashes: true,
          smooth: {
            enabled: true,
            type: "curvedCCW",
            roundness: 0.15
          }
        });
        edgeId++;
      }
      for (const client of company.clients) {
        edges.push({
          id: edgeId,
          from: client,
          to: company._id,
          arrows: "from",
          smooth: {
            enabled: true,
            type: "curvedCW",
            roundness: 0.15
          }
        });
        edgeId++;
      }
    }

    var container = document.getElementById("mynetwork");
    var data = {
      nodes: new vis.DataSet(nodes),
      edges: new vis.DataSet(edges)
    };
    var options = {
      locale: "fr",
      interaction: {
        dragNodes: false,
        hover: true,
        multiselect: true,
        tooltipDelay: 50
      },
      layout: {
        hierarchical: {
          enabled: true,
          levelSeparation: 180,
          nodeSpacing: 180,
          parentCentralization: true,
          direction: "RL",
          sortMethod: "directed"
        }
      },
      nodes: {
        borderWidth: 4,
        size: 30,
        color: {
          border: "#222222",
          background: "#666666"
        }
      },
      edges: {
        color: "black"
      },
      physics: false
    };

    var network = new vis.Network(container, data, options);
    network.on("selectNode", function(params) {
      network.focus(params.nodes, { scale: 1 });
    });
  },
  computed: {
    config() {
      return Config;
    }
  }
};
</script>

<style >
#mynetwork {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

</style>
